module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_6000.31c46f52.png";